import DoubleArrow from '@mui/icons-material/DoubleArrow';

export const DoubleArrowIcon = () => <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />;
